import { a as useAuthStore, h as ppapiClient, v as logger, q as glob, b as useConfigStore } from './prodsel.store-B-MQAyQE.mjs';
import 'pinia';
import 'vue';
import 'merkle-json';
import 'lodash';
import { M as MercureEvents } from './AutoQueue-Cbuqf1LW.mjs';
import 'vue-router';

class Mercure {

    constructor() {
        this.connected = false;
        this.hooks = {};
    }

    setCookie() {

        const that = this;
        const auth = useAuthStore();

        let endpoint = "access_mercure";

        // Session-ID immer mitsenden, damit Session-Topics auch im Login-Zustand
        // weiterhin autorisiert bleiben.
        if (auth.setup?.sessionId) {
            endpoint += "?sessionid=" + encodeURIComponent(auth.setup.sessionId);
        }

        let response = ppapiClient.get(endpoint).then((response) => {
            that.connected = Boolean(response?.success);
        }).catch((error) => {
            that.connected = false;
            logger.warn('mercure: setCookie fehlgeschlagen', error);
            throw error
        });
        return response

    }

    async connect(setCookie) {

        if (setCookie) {
           await this.setCookie();
        }

        glob("mercureEvents", MercureEvents);

    }

    async publish(topic,type,data) {

        const config = useConfigStore();
        const auth = useAuthStore();
        let hubUrl;

        try {
            hubUrl = new URL(config.hubUrl);
        } catch (error) {
            logger.error('mercure: publish übersprungen, ungültige hubUrl', [ config.hubUrl, error ]);
            return false
        }

        let kid = 0;
        if (auth?.user?.kid) kid = auth.user.kid;
        let id = 0;
        if (auth?.setup?.sessionId) id = auth.setup.sessionId;

        const postData = {
            type: type,
            data: data
        };
        const params = new URLSearchParams(postData);

        if (topic[0] == "/") params.append("topic", topic);
        else {
            if (kid != 0) params.append("topic", config.apiUrl + config.apiPath + "/users/" + kid + "/" + topic);
            else params.append("topic",config.apiUrl + config.apiPath + "/sessions/" + id + "/" + topic);
        }

        const eventData = new URLSearchParams(postData).toString();
        let response;

        try {
            response = await fetch(hubUrl, {
                method: "POST",
                credentials: 'include',
                headers:{
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: params,
            });
        } catch (error) {
            this.notifyHooks(type, postData, {success: false, origin: "local", data: eventData, error});
            throw error
        }

        if (!response.ok) {
            logger.error('mercure: publish fehlgeschlagen', [ response.status, response.statusText ]);
        }  else {
            logger.debug('mercure: publish erfolgreich', [ topic, type, data ]);
        }
        // This is how to read the mercure uuid. (Currently not used)
        // TODO: Could be used to register event IDs in order to filter own events in MercureEvents
        //const text = await response.text();
        //console.log(text);

        this.notifyHooks(type, postData, {success: response.ok, origin: "local", data: eventData});
          
        return response
    }

    notifyHooks(type, data, event) {
        Object.keys(this.hooks).forEach((name) => {
            const hook = this.hooks[name];
            if (typeof hook.func == "function") {
                hook.func(type, data, event, hook.options);
            }
        });
    }

    addHook(name, func, options) {

        if (typeof func != "function") {
            logger.error("mercure: Hook function is not a function", name, func);
            return
        }

        if (!this.hooks[name]) this.hooks[name] = {};
        this.hooks[name] = {func: func, options: options};

        logger.debug("mercure: add hook " + name);

        return  this.hooks[name]

    }

    removeHook(name) {
        if (this.hooks[name]) {
            delete this.hooks[name];
            logger.debug("mercure: remove hook " + name);
        } else {
            logger.warn("mercure: remove hook " + name + " not found");
        }
    }

}

class User {

  constructor() {

  }

  logout() {

    this.authStore = useAuthStore();
    this.authStore.logout();

  }

  getSessionId() {

    this.authStore = useAuthStore();
    return this.authStore.getSessionId()

  }
}

export { Mercure as M, User as U };
